import { lazy } from "react";

const WisdomOnboarding = lazy(() => import("pages/ServicePages/WisdomOnboarding/WisdomOnboarding"));

export const onBoarding = [
  {
    path: "setup_wizard",
    element: <WisdomOnboarding />,
  },
];
